// extracted by mini-css-extract-plugin
module.exports = {"sender":"sender___vIoge","toolBar":"toolBar___31ClY","icon":"icon___oMArF","inputArea":"inputArea___317hs"};